import Vue from 'vue';
import Vuex from 'vuex';
import system from "./system";
import keyvalue from "./keyvalue"
import customer from "./customer"
import dashboard from "./dashboard"

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    system,
    keyvalue,
    customer,
    dashboard
  },
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js